<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
  
            <div class="alpha-land-container">
    <h2 class="title">🎲 Poker Paws' Adventure in Alpha Land! 🎲</h2>
    <div class="image-with-text">
      <img src="https://assets.codepen.io/11151897/pokerpawsalpha.png" alt="Poker Paws Image" class="responsive-image"/>
      <p>Welcome, risky cats, to the thrilling world of stock market poker, where I, Poker Paws, will be continuing to guide you through the mysterious jungle of Jensen's Alpha!</p>
      <p>🃏 What's Jensen's Alpha, You Ask? In our high-stakes game of market poker, Jensen's Alpha is like your personal scoreboard. It tells you how well you've played your hand (your portfolio) compared to the rest of the table (the market). It's the answer to the question: "Have I outsmarted the market with my strategic plays, or is it time to rethink my approach?"</p>
    </div></div>
  
  <ul><h3>♦️ The Cards in Your Hand: ♣️</h3></ul>
  <li><strong>Your Ace - Personal Portfolio Returns:</strong> These are the wins and losses from your portfolio, a record of your strategic plays over time. It's like looking back at the hands you've played to see how well you've done.</li>
   <br> <li><strong>The Safe Bet - Risk-Free Rate:</strong> This is the easiest bet in the game, where you face no bluffs or surprises. It's the interest rate of a super-safe investment, like the SOFR rate (which has been included below to make life easier) or you could consider if your broker is offering you a great rate for sitting in cash.</li>
   <br>  <li><strong>The House Rules - Market Index Rate:</strong>This is what the average player at the table is earning. It's like the S&P 500's return rate, showing how the game is going for everyone else.</li>
   <br>   <li><strong>Your Poker Strategy - Portfolio Beta: </strong>This is how risky your plays have been compared to the average player. The RiskyPaws’ Beta Calculator helps you figure out if you're playing it safe or going all-in.</li>
  <br><strong>🔮 Casting the Alpha Magic:</strong>
  Gather your cards, and let's see how you've fared. We'll calculate if your wins (portfolio returns) outshine the average player, given the risks you've taken. A high Alpha? You're a poker legend! A low Alpha? Time to shuffle your strategy.
  
  <ul><h3>♠️ Reading the Poker Tells of Jensen's Alpha:♥️</h3></ul>
  
  <strong>🚀 Alpha Over Zero: You're Bluffing the Market!</strong>
  
  <li>Meaning: A positive Alpha means you've outbluffed the market. Your strategies and risks have paid off, earning you more than the average player.
  Poker Paws' Shoutout: "Bravo! You've got the poker face and the skills to beat the market. Keep playing those cards right, and you might just become a legend!"</li>
  <br>
  
  <strong>🐾 Alpha Under Zero: Time to Review Your Hand</strong>
  
  <li>Meaning: A negative Alpha is like a bad hand in poker. It means your strategies haven't paid off as well as playing it by the book (market index).
  Poker Paws' Wisdom: "Not every hand's a winner, but every hand's a lesson. Maybe it's time to consider playing alongside the house by investing in Market Index ETFs, where the play is steady and predictable."
  </li>
  <br>
  <strong>👀 Alpha Around Zero: You're Matching the Market</strong>
  
  <li>Meaning: An Alpha near zero? You're playing in sync with the house. Your returns are on par with the average market player.
  Poker Paws' Encouragement: "Nice play! You're keeping pace with the market. With a bit more strategy and learning, who knows? You might just outplay the house!"</li>
  <br>
  <strong>Poker Paws' Final Tip:</strong>
  Remember, Jensen's Alpha is like your poker history book. Use it wisely along with your other poker skills for future games. Whether you're outbluffing the market or playing by the house rules, every game is a chance to grow. Keep playing, keep learning, and may the odds be ever in your favour! 🎲🐾
  
  <br><br> <i>p.s. Just a quick note from TrailBlazer Tabby - RiskyPaws offers a financial diary feature in the planning section of the framework to track all of your trading history including asking you why you chose to make that investment.  It may be a great idea to review this in tandem at a regular interval to ensure you are. </i>
  <br><br> <i>p.p.s. Your portfolio return should easily be available from your broker's site. The market return depends upon what your portfolio is based against so please use our in-depth screener to see what makes sense for you.  SOFR and other government bonds and treasuries are easily accessible in the yield section of the framework.  The beta calculator is found in the wealth management framework section that you are currently in. We believe by making you chase the laser point here it'll help increase your awareness and help you learn to navigate all the wonderful tidbits available on RiskyPaws.</i>
  
          <h2>Jensen's Alpha Calculator</h2>
          <div>
            <h3>Calculate Your Portfolio's Jensen's Alpha</h3>
            <form @submit.prevent="calculateJensensAlpha">
              <input class="styled-input" type="number" v-model.number="portfolioReturn" placeholder="Your Portfolio Return (%)" step="0.0001">
            <input class="styled-input" type="number" v-model.number="marketReturn" placeholder="Market Return (%)" step="0.0001">
            <input class="styled-input" type="number" v-model.number="sofrRate" placeholder="SOFR Rate (%)" step="0.0001">
            <input class="styled-input" type="number" v-model.number="portfolioBeta" placeholder="Your Portfolio Beta" step="0.0001">
              <button type="submit" class="alpha">Calculate Jensen's Alpha</button>
            </form>
            <div v-if="jensensAlpha !== null">
              <h3>Your Portfolio's Jensen's Alpha: {{ jensensAlpha.toFixed(4) }}</h3>
            </div>
            <br><br>
            <iframe height="300" style="width: 100%;" scrolling="no" title="Sticky Notes" src="https://codepen.io/Farah-Kamal/embed/rNPWxya/9c047bc3e3b425f7d7751f1435df5b94?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true"></iframe>
          </div>
        </div>
        </div>
      </div><br><br><br><br><br><br><br>
  </template>
  
  <script>
  export default {
    data() {
      return {
        portfolioReturn: '',
        marketReturn: '',
        sofrRate: '', 
        portfolioBeta: '', 
        jensensAlpha: null,
      };
    },
    computed: {
      formattedSofrRate() {
        return this.sofrRate.toFixed(4);
      },
      formattedPortfolioBeta() {
        return this.portfolioBeta.toFixed(4);
      }
    },
    methods: {
      calculateJensensAlpha() {
        let adjustedSofrRate = parseFloat(this.formattedSofrRate);
        let adjustedPortfolioBeta = parseFloat(this.formattedPortfolioBeta);
        this.jensensAlpha = this.portfolioReturn - (adjustedSofrRate + adjustedPortfolioBeta * (this.marketReturn - adjustedSofrRate));
      },
    }
  }
  </script>
  
  <style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content-container {
  background-color: #4A148C;
  color: black;
  padding: 20px;
  border-radius: 20px;
  overflow: hidden;
}

.stingy-card {
  flex: 1;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
}

.styled-input {
  margin: 5px 0;
  padding: 12px; /* Increased padding for better touch interaction */
  border-radius: 5px;
  border: 1px solid #ccc;
  width: calc(100% - 24px); /* Adjust width to be responsive */
  box-sizing: border-box; /* Ensure padding doesn't affect the total width */
}

.responsive-image {
  max-width: 100%; /* Make image width responsive */
  height: auto; /* Maintain aspect ratio */
}

 .alpha {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}

.alpha:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}

/* Other styles remain the same */
</style>